/* 
 * Status to class service
 * Angular module: "trackerbase-app.services.status-class-service"
 * Service Name: StatusClass
 */ 
import angular from "angular";

const defaultBootstrapClass = "default";

const bootstrapClassStatusTable = new Map([
    [undefined, defaultBootstrapClass],
    ["Proposed", "info"],
    ["Scheduled", "primary"],
    ["Tracked - Access Denied", "success"],
    ["Tracked - Reported", "success"],
    ["Cancelled", "warning"],
    ["Not Tracked", "warning"],
    ["Rejected", "danger"]
]);

const defaultStatusClass = "tb-no-status";
const classForStatusNameTable = new Map([
    [undefined, defaultStatusClass],
    ["Proposed", "tb-proposed"],
    ["Scheduled", "tb-scheduled"],
    ["Tracked - Access Denied", "tb-tracked-denied"],
    ["Tracked - Reported", "tb-tracked-success"],
    ["Cancelled", "tb-cancelled"],
    ["Not Tracked", "tb-not-tracked"],
    ["Rejected", "tb-rejected"]
]);

class StatusClassService {
    constructor() {}

    getBootstrapStatusLabelType(sName) {
        let statusLabelName = bootstrapClassStatusTable.get(sName);
        if (angular.isUndefined(statusLabelName)) {
            statusLabelName = defaultBootstrapClass;
        }
        return statusLabelName;
    }
    
    getClassForStatus(statusName) {
        let statusClass = classForStatusNameTable.get(statusName);
        if (angular.isUndefined(statusClass)) {
            statusClass = defaultStatusClass;
        }
        return statusClass;
    }
    
    getAllStatusClassesIterator() {
        return classForStatusNameTable.values();
    }
}

StatusClassService.$inject = [];

export default angular
    .module("trackerbase-app.services.status-class-service",[
    ])
    .service("StatusClass", StatusClassService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/StatusClassService.js
// module id = CAmN
// module chunks = 1